var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { AccordionSet, Accordion, Checkbox, Button, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
import { useQuery } from "react-query";
import { RecekTextField, RecekSelect } from "./inputs";
import { fetchLibraries } from "../api/libraryService";
export var UserFilters = function (_a) {
    var _b;
    var filters = _a.filters, onFilterChange = _a.onFilterChange, onStatusChange = _a.onStatusChange, onRoleChange = _a.onRoleChange, onApplyFilters = _a.onApplyFilters, hasUnappliedChanges = _a.hasUnappliedChanges;
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    var ky = useOkapiKy();
    var librariesData = useQuery(["libraries"], function () { return fetchLibraries(ky); }).data;
    var userStatuses = ["active", "inactive"];
    var userRoles = ["admin", "librarian"];
    return (React.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            onApplyFilters();
        } },
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.userName",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-legaldeposits.filter.userName", showLabel: false, value: filters.name, onChange: function (e) { return onFilterChange("name", e.target.value); }, placeholder: formatMessage({
                        id: "ui-br-legaldeposits.filter.userName.placeholder",
                    }) })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.library",
                }), separator: false },
                React.createElement(RecekSelect, { labelId: "ui-br-legaldeposits.filter.library", showLabel: false, value: filters.libraryId, onChange: function (e) {
                        return onFilterChange("libraryId", e.target.value);
                    }, dataOptions: __spreadArray([
                        {
                            value: "",
                            label: formatMessage({
                                id: "ui-br-legaldeposits.filter.select.all",
                            }),
                        }
                    ], ((_b = librariesData === null || librariesData === void 0 ? void 0 : librariesData.items) !== null && _b !== void 0 ? _b : []).map(function (library) {
                        var _a, _b;
                        return ({
                            value: (_a = library.id) !== null && _a !== void 0 ? _a : "",
                            label: (_b = library.name) !== null && _b !== void 0 ? _b : "",
                        });
                    }), true) })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.status",
                }), separator: false }, userStatuses.map(function (status) { return (React.createElement(Checkbox, { key: status, label: formatMessage({
                    id: "ui-br-legaldeposits.userStatus.".concat(status),
                }), checked: filters.statuses.includes(status), onChange: function () { return onStatusChange(status); } })); })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.role",
                }), separator: false }, userRoles.map(function (role) { return (React.createElement(Checkbox, { key: role, label: formatMessage({
                    id: "ui-br-legaldeposits.userRole.".concat(role),
                }), checked: filters.roles.includes(role), onChange: function () { return onRoleChange(role); } })); }))),
        React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, type: "submit", disabled: !hasUnappliedChanges },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.apply" }))));
};
